import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';

export class ChestIdle extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        const sy: number = transform.scale.y;
        const pulseTween = this.getTween(transform.scale);

        pulseTween
            .to({ y: sy + 0.04 }, 600)
            .easing(Easing.Sinusoidal.Out)
            .yoyo(true)
            .repeat(Infinity);

        yield* this.startTween(pulseTween);
    }
}
